/**
 * <sticky-atc> — mobile sticky add-to-cart.
 * Reveals once the main add-to-cart button scrolls above the viewport.
 * The button shares the main product form (form=…), so the currently
 * selected variant is what gets added. Desktop hides it via CSS.
 */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        const anchor = document.getElementById('ProductSubmitButton-' + this.dataset.section);
        if (!anchor || !('IntersectionObserver' in window)) return;
        this._io = new IntersectionObserver(
          (entries) => {
            const e = entries[0];
            // Show only when the main button has scrolled ABOVE the viewport.
            const show = !e.isIntersecting && e.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', show);
            this.setAttribute('aria-hidden', show ? 'false' : 'true');
          },
          { threshold: 0, rootMargin: '0px 0px -20% 0px' }
        );
        this._io.observe(anchor);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }
    }
  );
}
